import { render } from "./ModalInformationCustomer.vue?vue&type=template&id=8f910c50&scoped=true"
import script from "./ModalInformationCustomer.vue?vue&type=script&lang=js"
export * from "./ModalInformationCustomer.vue?vue&type=script&lang=js"

import "./ModalInformationCustomer.vue?vue&type=style&index=0&id=8f910c50&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f910c50"]])

export default __exports__